import ProjectScopeDocModule from './project-scope-doc.module'

export default ProjectScopeDocModule
